import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchFloorplan } from '../services/patchFloorplan.service';

export const updateFloorplan = createAsyncThunk(
  'floorplans/updateFloorplan',
  async ({ floorplanId, projectId, name, placementMandatory }) => {
    const updateParams = { name, placementMandatory };

    const floorplan = await patchFloorplan(
      floorplanId,
      projectId,
      updateParams
    );
    return floorplan;
  }
);
